import { Api } from "../../api";

export const fetchProduct = (code, host, reset = false) => {
  return async (dispatch) => {
    const response = await Api.server.getProduct(code, host, reset);
    dispatch({ type: "FETCH_PRODUCT", payload: response });
  };
};

export const fetchDelivery = (
  productIds,
  destinationWarehouses,
  time,
  weekday,
  isReset = false,
) => {
  return async (dispatch) => {
    const response = await Api.server.getProductDelivery(
      productIds,
      destinationWarehouses,
      time,
      weekday,
      isReset,
    );
    dispatch({ type: "FETCH_DELIVERY_NEW", payload: response[productIds] });
  };
};
